import { render, staticRenderFns } from "./LoadingIcon.vue?vue&type=template&id=afab76f2&scoped=true"
import script from "./LoadingIcon.vue?vue&type=script&lang=js"
export * from "./LoadingIcon.vue?vue&type=script&lang=js"
import style0 from "./LoadingIcon.vue?vue&type=style&index=0&id=afab76f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afab76f2",
  null
  
)

export default component.exports